export type BreakpointName = '_' | 'xs' | 'sm' | 'md' | 'lg';
export type Breakpoint = { name: BreakpointName; min: number | null };

export const BREAKPOINTS: Array<Breakpoint> = [
  { name: 'lg', min: 1440 },
  { name: 'md', min: 1280 },
  { name: 'sm', min: 768 },
  { name: 'xs', min: 360 },
  { name: '_', min: null },
];
